import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { SaveDefinitionModalPage } from './save-definition-modal.page';

const routes: Routes = [
  {
    path: '',
    component: SaveDefinitionModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [SaveDefinitionModalPage],
  entryComponents: [SaveDefinitionModalPage]
})
export class SaveDefinitionModalPageModule {}
